var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87525 11.9861L4.59604 11.2653L2.73465 9.40396L2.01386 10.1248V10.9723H3.02772V11.9861H3.87525ZM8.01782 4.63564C8.01782 4.51947 7.95973 4.46139 7.84356 4.46139C7.79076 4.46139 7.74588 4.47987 7.70891 4.51684L3.41584 8.80991C3.37891 8.84687 3.36044 8.89176 3.36044 8.94456C3.36044 9.06073 3.41852 9.11882 3.53469 9.11882C3.58749 9.11882 3.63238 9.10033 3.66935 9.06337L7.96242 4.7703C7.99935 4.73333 8.01782 4.68845 8.01782 4.63564ZM7.5901 3.11485L10.8851 6.4099L4.29505 13H1V9.70495L7.5901 3.11485ZM13 3.87525C13 4.15512 12.9023 4.39274 12.7069 4.58812L11.3921 5.90297L8.09703 2.60792L9.41188 1.30099C9.60198 1.10033 9.8396 1 10.1248 1C10.4046 1 10.6449 1.10033 10.8455 1.30099L12.7069 3.15445C12.9023 3.3604 13 3.60066 13 3.87525Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3b6b97ff561ece036c80e2300ce0dff7.svg";
export { ForwardRef as ReactComponent };